import { Alert, Box, Link } from '@mui/material';
import PageHeader from 'components/BaseLayout/PageHeader';
import NotificationPanel from 'components/Shared/NotificationPanel';
import { useAppDispatch, useAppSelector } from 'core/hooks/hooks';
import { useEntityContext } from 'core/hooks/useEntityContext';
import { NotificationContextProvider } from 'core/providers/NotificationContextProvider';
import { listIncomes } from 'core/store/actions/incomes.actions';
import { incomesSelector } from 'core/store/selectors/incomes.selector';
import { useEffect, useState } from 'react';
import EditIncomeForm from './EditIncomeForm';
import IncomesList from './list/IncomesList';

const IncomesPage = () => {
  const context = useEntityContext<string>();
  const dispatch = useAppDispatch();
  const [editPanelOpen, setEditPanelOpen] = useState<boolean>(false);

  const { incomes, hasLoaded } = useAppSelector(incomesSelector);

  useEffect(() => {
    if (!hasLoaded) {
      dispatch(listIncomes());
    }
  }, []);

  const openEditForm = () => {
    setEditPanelOpen(true);
  };

  const closeEditForm = () => {
    context.reset();
    setEditPanelOpen(false);
  };

  return (
    <NotificationContextProvider>
      <Box>
        <PageHeader
          title="Incomes"
          buttons={{
            buttons: [{ title: 'Add Income', onClick: openEditForm }]
          }}
        />
        {incomes.length ? (
          <IncomesList
            context={context}
            openEditForm={openEditForm}
            incomes={incomes}
          />
        ) : (
          <Alert severity="warning">
            No incomes.{' '}
            {
              <Link href="#" onClick={openEditForm}>
                Add a new one
              </Link>
            }
          </Alert>
        )}

        <EditIncomeForm
          isOpen={editPanelOpen}
          closePanel={closeEditForm}
          incomeId={context.current}
        />
        <NotificationPanel />
      </Box>
    </NotificationContextProvider>
  );
};

export default IncomesPage;
